const STATUS_MESSAGES = {
  invalid:
    '指定されたファイルは無効です。ファイルを確認のうえ再度お試しください',
  'ocr-failed':
    'OCR 処理で一時的なエラーが発生しました。時間を置いて再度お試しください',
  'internal-error':
    '一時的なエラーが発生しました。時間を置いて再度お試しください',
} as const

export type ProcessingState = 'completed' | 'processing' | 'failed'
export type JobStatusType =
  | 'accepted'
  | 'invalid'
  | 'inprogress'
  | 'ocr-failed'
  | 'internal-error'
  | 'completed'

const PROCESSING_STATE: Record<string, ProcessingState> = {
  COMPLETED: 'completed',
  PROCESSING: 'processing',
  FAILED: 'failed',
}
const JOB_STATUS: Record<string, JobStatusType> = {
  ACCEPTED: 'accepted',
  INVALID: 'invalid',
  INPROGRESS: 'inprogress',
  OCR_FAILED: 'ocr-failed',
  INTERNAL_ERROR: 'internal-error',
  COMPLETED: 'completed',
}

export class Job {
  constructor(
    public jobID: string,
    public originalJobID: string,
    public docName: string,
    public docType: string,
    public fileExt: string,
    public pageSize: number,
    public businessID: string,
    public assigneeBusinessID: string,
    public status: JobStatusType,
    public subGroup: string,
    public objectID: string,
    public message: string,
    // should be decided with if this.subgroup is in [verify groups]
    public _isVerify?: boolean,
  ) {}

  statusType(): ProcessingState {
    const status = this.status
    if (status === JOB_STATUS.COMPLETED) {
      return PROCESSING_STATE.COMPLETED
    }

    if (status === JOB_STATUS.INPROGRESS || status === JOB_STATUS.ACCEPTED) {
      return PROCESSING_STATE.PROCESSING
    }

    return PROCESSING_STATE.FAILED
  }

  isCompleted(): boolean {
    return this.statusType() === PROCESSING_STATE.COMPLETED
  }

  isFailed(): boolean {
    return this.statusType() === PROCESSING_STATE.FAILED
  }

  isProcessing(): boolean {
    return this.statusType() === PROCESSING_STATE.PROCESSING
  }

  isInvalid(): boolean {
    return this.status === JOB_STATUS.INVALID
  }

  decideIsVerify(vGroups: string[]) {
    this._isVerify = vGroups.includes(this.subGroup)
  }

  // isVerify can be obtained from the server as a real member in the future
  get isVerify() {
    if (this._isVerify === undefined)
      throw new Error('get isVerify before deciding it')
    return this._isVerify
  }

  displayMessage(): string {
    return this.message || STATUS_MESSAGES[this.status] || ''
  }
}
